module.exports = __webpack_public_path__ + "img/box-left2.673bcd22.png";